/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	JSON: `scalar.JSON` as const,
	DateTime: `scalar.DateTime` as const,
	PublicationStatus: "enum" as const,
	IDFilterInput:{
		not:"IDFilterInput"
	},
	BooleanFilterInput:{
		not:"BooleanFilterInput"
	},
	StringFilterInput:{
		not:"StringFilterInput"
	},
	IntFilterInput:{
		not:"IntFilterInput"
	},
	FloatFilterInput:{
		not:"FloatFilterInput"
	},
	DateTimeFilterInput:{
		and:"DateTime",
		or:"DateTime",
		not:"DateTimeFilterInput",
		eq:"DateTime",
		eqi:"DateTime",
		ne:"DateTime",
		nei:"DateTime",
		startsWith:"DateTime",
		endsWith:"DateTime",
		contains:"DateTime",
		notContains:"DateTime",
		containsi:"DateTime",
		notContainsi:"DateTime",
		gt:"DateTime",
		gte:"DateTime",
		lt:"DateTime",
		lte:"DateTime",
		in:"DateTime",
		notIn:"DateTime",
		between:"DateTime"
	},
	JSONFilterInput:{
		and:"JSON",
		or:"JSON",
		not:"JSONFilterInput",
		eq:"JSON",
		eqi:"JSON",
		ne:"JSON",
		nei:"JSON",
		startsWith:"JSON",
		endsWith:"JSON",
		contains:"JSON",
		notContains:"JSON",
		containsi:"JSON",
		notContainsi:"JSON",
		gt:"JSON",
		gte:"JSON",
		lt:"JSON",
		lte:"JSON",
		in:"JSON",
		notIn:"JSON",
		between:"JSON"
	},
	ComponentLandingWorkExampleFiltersInput:{
		title:"StringFilterInput",
		description:"StringFilterInput",
		and:"ComponentLandingWorkExampleFiltersInput",
		or:"ComponentLandingWorkExampleFiltersInput",
		not:"ComponentLandingWorkExampleFiltersInput"
	},
	ComponentLandingWorkExampleInput:{

	},
	ComponentLandingFaqFiltersInput:{
		question:"StringFilterInput",
		answer:"StringFilterInput",
		and:"ComponentLandingFaqFiltersInput",
		or:"ComponentLandingFaqFiltersInput",
		not:"ComponentLandingFaqFiltersInput"
	},
	ComponentLandingFaqInput:{

	},
	UploadFileFiltersInput:{
		documentId:"IDFilterInput",
		name:"StringFilterInput",
		alternativeText:"StringFilterInput",
		caption:"StringFilterInput",
		width:"IntFilterInput",
		height:"IntFilterInput",
		formats:"JSONFilterInput",
		hash:"StringFilterInput",
		ext:"StringFilterInput",
		mime:"StringFilterInput",
		size:"FloatFilterInput",
		url:"StringFilterInput",
		previewUrl:"StringFilterInput",
		provider:"StringFilterInput",
		provider_metadata:"JSONFilterInput",
		folderPath:"StringFilterInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"UploadFileFiltersInput",
		and:"UploadFileFiltersInput",
		or:"UploadFileFiltersInput",
		not:"UploadFileFiltersInput"
	},
	I18NLocaleFiltersInput:{
		documentId:"IDFilterInput",
		name:"StringFilterInput",
		code:"StringFilterInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"I18NLocaleFiltersInput",
		and:"I18NLocaleFiltersInput",
		or:"I18NLocaleFiltersInput",
		not:"I18NLocaleFiltersInput"
	},
	ReviewWorkflowsWorkflowFiltersInput:{
		documentId:"IDFilterInput",
		name:"StringFilterInput",
		stages:"ReviewWorkflowsWorkflowStageFiltersInput",
		contentTypes:"JSONFilterInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"ReviewWorkflowsWorkflowFiltersInput",
		and:"ReviewWorkflowsWorkflowFiltersInput",
		or:"ReviewWorkflowsWorkflowFiltersInput",
		not:"ReviewWorkflowsWorkflowFiltersInput"
	},
	ReviewWorkflowsWorkflowInput:{
		contentTypes:"JSON",
		publishedAt:"DateTime"
	},
	ReviewWorkflowsWorkflow:{
		stages_connection:{
			filters:"ReviewWorkflowsWorkflowStageFiltersInput",
			pagination:"PaginationArg"
		},
		stages:{
			filters:"ReviewWorkflowsWorkflowStageFiltersInput",
			pagination:"PaginationArg"
		}
	},
	ReviewWorkflowsWorkflowStageFiltersInput:{
		documentId:"IDFilterInput",
		name:"StringFilterInput",
		color:"StringFilterInput",
		workflow:"ReviewWorkflowsWorkflowFiltersInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"ReviewWorkflowsWorkflowStageFiltersInput",
		and:"ReviewWorkflowsWorkflowStageFiltersInput",
		or:"ReviewWorkflowsWorkflowStageFiltersInput",
		not:"ReviewWorkflowsWorkflowStageFiltersInput"
	},
	ReviewWorkflowsWorkflowStageInput:{
		publishedAt:"DateTime"
	},
	UsersPermissionsPermissionFiltersInput:{
		documentId:"IDFilterInput",
		action:"StringFilterInput",
		role:"UsersPermissionsRoleFiltersInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"UsersPermissionsPermissionFiltersInput",
		and:"UsersPermissionsPermissionFiltersInput",
		or:"UsersPermissionsPermissionFiltersInput",
		not:"UsersPermissionsPermissionFiltersInput"
	},
	UsersPermissionsRoleFiltersInput:{
		documentId:"IDFilterInput",
		name:"StringFilterInput",
		description:"StringFilterInput",
		type:"StringFilterInput",
		permissions:"UsersPermissionsPermissionFiltersInput",
		users:"UsersPermissionsUserFiltersInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"UsersPermissionsRoleFiltersInput",
		and:"UsersPermissionsRoleFiltersInput",
		or:"UsersPermissionsRoleFiltersInput",
		not:"UsersPermissionsRoleFiltersInput"
	},
	UsersPermissionsRoleInput:{
		publishedAt:"DateTime"
	},
	UsersPermissionsRole:{
		permissions_connection:{
			filters:"UsersPermissionsPermissionFiltersInput",
			pagination:"PaginationArg"
		},
		permissions:{
			filters:"UsersPermissionsPermissionFiltersInput",
			pagination:"PaginationArg"
		},
		users_connection:{
			filters:"UsersPermissionsUserFiltersInput",
			pagination:"PaginationArg"
		},
		users:{
			filters:"UsersPermissionsUserFiltersInput",
			pagination:"PaginationArg"
		}
	},
	UsersPermissionsUserFiltersInput:{
		documentId:"IDFilterInput",
		username:"StringFilterInput",
		email:"StringFilterInput",
		provider:"StringFilterInput",
		password:"StringFilterInput",
		resetPasswordToken:"StringFilterInput",
		confirmationToken:"StringFilterInput",
		confirmed:"BooleanFilterInput",
		blocked:"BooleanFilterInput",
		role:"UsersPermissionsRoleFiltersInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"UsersPermissionsUserFiltersInput",
		and:"UsersPermissionsUserFiltersInput",
		or:"UsersPermissionsUserFiltersInput",
		not:"UsersPermissionsUserFiltersInput"
	},
	UsersPermissionsUserInput:{
		publishedAt:"DateTime"
	},
	BlogFiltersInput:{
		documentId:"IDFilterInput",
		title:"StringFilterInput",
		slug:"StringFilterInput",
		writer:"WriterFiltersInput",
		category:"CategoryFiltersInput",
		content:"StringFilterInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"BlogFiltersInput",
		and:"BlogFiltersInput",
		or:"BlogFiltersInput",
		not:"BlogFiltersInput"
	},
	BlogInput:{
		publishedAt:"DateTime"
	},
	CategoryFiltersInput:{
		documentId:"IDFilterInput",
		name:"StringFilterInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"CategoryFiltersInput",
		and:"CategoryFiltersInput",
		or:"CategoryFiltersInput",
		not:"CategoryFiltersInput"
	},
	CategoryInput:{
		publishedAt:"DateTime"
	},
	HomeInput:{
		usecase:"ComponentLandingWorkExampleInput",
		faq:"ComponentLandingFaqInput",
		publishedAt:"DateTime"
	},
	Home:{
		usecase:{
			filters:"ComponentLandingWorkExampleFiltersInput",
			pagination:"PaginationArg"
		},
		faq:{
			filters:"ComponentLandingFaqFiltersInput",
			pagination:"PaginationArg"
		}
	},
	WriterFiltersInput:{
		documentId:"IDFilterInput",
		name:"StringFilterInput",
		createdAt:"DateTimeFilterInput",
		updatedAt:"DateTimeFilterInput",
		publishedAt:"DateTimeFilterInput",
		locale:"StringFilterInput",
		localizations:"WriterFiltersInput",
		and:"WriterFiltersInput",
		or:"WriterFiltersInput",
		not:"WriterFiltersInput"
	},
	WriterInput:{
		publishedAt:"DateTime"
	},
	FileInfoInput:{

	},
	UsersPermissionsRegisterInput:{

	},
	UsersPermissionsLoginInput:{

	},
	PaginationArg:{

	},
	Query:{
		uploadFile:{
			status:"PublicationStatus"
		},
		uploadFiles_connection:{
			filters:"UploadFileFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		uploadFiles:{
			filters:"UploadFileFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		i18NLocale:{
			status:"PublicationStatus"
		},
		i18NLocales_connection:{
			filters:"I18NLocaleFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		i18NLocales:{
			filters:"I18NLocaleFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		reviewWorkflowsWorkflow:{
			status:"PublicationStatus"
		},
		reviewWorkflowsWorkflows_connection:{
			filters:"ReviewWorkflowsWorkflowFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		reviewWorkflowsWorkflows:{
			filters:"ReviewWorkflowsWorkflowFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		reviewWorkflowsWorkflowStage:{
			status:"PublicationStatus"
		},
		reviewWorkflowsWorkflowStages_connection:{
			filters:"ReviewWorkflowsWorkflowStageFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		reviewWorkflowsWorkflowStages:{
			filters:"ReviewWorkflowsWorkflowStageFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		usersPermissionsRole:{
			status:"PublicationStatus"
		},
		usersPermissionsRoles_connection:{
			filters:"UsersPermissionsRoleFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		usersPermissionsRoles:{
			filters:"UsersPermissionsRoleFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		usersPermissionsUser:{
			status:"PublicationStatus"
		},
		usersPermissionsUsers_connection:{
			filters:"UsersPermissionsUserFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		usersPermissionsUsers:{
			filters:"UsersPermissionsUserFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		blog:{
			status:"PublicationStatus"
		},
		blogs_connection:{
			filters:"BlogFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		blogs:{
			filters:"BlogFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		category:{
			status:"PublicationStatus"
		},
		categories_connection:{
			filters:"CategoryFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		categories:{
			filters:"CategoryFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		home:{
			status:"PublicationStatus"
		},
		writer:{
			status:"PublicationStatus"
		},
		writers_connection:{
			filters:"WriterFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		},
		writers:{
			filters:"WriterFiltersInput",
			pagination:"PaginationArg",
			status:"PublicationStatus"
		}
	},
	Mutation:{
		createReviewWorkflowsWorkflow:{
			status:"PublicationStatus",
			data:"ReviewWorkflowsWorkflowInput"
		},
		updateReviewWorkflowsWorkflow:{
			status:"PublicationStatus",
			data:"ReviewWorkflowsWorkflowInput"
		},
		deleteReviewWorkflowsWorkflow:{

		},
		createReviewWorkflowsWorkflowStage:{
			status:"PublicationStatus",
			data:"ReviewWorkflowsWorkflowStageInput"
		},
		updateReviewWorkflowsWorkflowStage:{
			status:"PublicationStatus",
			data:"ReviewWorkflowsWorkflowStageInput"
		},
		deleteReviewWorkflowsWorkflowStage:{

		},
		createBlog:{
			status:"PublicationStatus",
			data:"BlogInput"
		},
		updateBlog:{
			status:"PublicationStatus",
			data:"BlogInput"
		},
		deleteBlog:{

		},
		createCategory:{
			status:"PublicationStatus",
			data:"CategoryInput"
		},
		updateCategory:{
			status:"PublicationStatus",
			data:"CategoryInput"
		},
		deleteCategory:{

		},
		updateHome:{
			status:"PublicationStatus",
			data:"HomeInput"
		},
		createWriter:{
			status:"PublicationStatus",
			data:"WriterInput"
		},
		updateWriter:{
			status:"PublicationStatus",
			data:"WriterInput"
		},
		deleteWriter:{

		},
		updateUploadFile:{
			info:"FileInfoInput"
		},
		deleteUploadFile:{

		},
		createUsersPermissionsRole:{
			data:"UsersPermissionsRoleInput"
		},
		updateUsersPermissionsRole:{
			data:"UsersPermissionsRoleInput"
		},
		deleteUsersPermissionsRole:{

		},
		createUsersPermissionsUser:{
			data:"UsersPermissionsUserInput"
		},
		updateUsersPermissionsUser:{
			data:"UsersPermissionsUserInput"
		},
		deleteUsersPermissionsUser:{

		},
		login:{
			input:"UsersPermissionsLoginInput"
		},
		register:{
			input:"UsersPermissionsRegisterInput"
		},
		forgotPassword:{

		},
		resetPassword:{

		},
		changePassword:{

		},
		emailConfirmation:{

		}
	}
}

export const ReturnTypes: Record<string,any> = {
	JSON: `scalar.JSON` as const,
	DateTime: `scalar.DateTime` as const,
	Pagination:{
		total:"Int",
		page:"Int",
		pageSize:"Int",
		pageCount:"Int"
	},
	DeleteMutationResponse:{
		documentId:"ID"
	},
	ComponentLandingWorkExample:{
		id:"ID",
		image:"UploadFile",
		title:"String",
		description:"String"
	},
	ComponentLandingFaq:{
		id:"ID",
		question:"String",
		answer:"String"
	},
	UploadFile:{
		documentId:"ID",
		name:"String",
		alternativeText:"String",
		caption:"String",
		width:"Int",
		height:"Int",
		formats:"JSON",
		hash:"String",
		ext:"String",
		mime:"String",
		size:"Float",
		url:"String",
		previewUrl:"String",
		provider:"String",
		provider_metadata:"JSON",
		related:"GenericMorph",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	UploadFileEntityResponseCollection:{
		nodes:"UploadFile",
		pageInfo:"Pagination"
	},
	I18NLocale:{
		documentId:"ID",
		name:"String",
		code:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	I18NLocaleEntityResponseCollection:{
		nodes:"I18NLocale",
		pageInfo:"Pagination"
	},
	ReviewWorkflowsWorkflow:{
		documentId:"ID",
		name:"String",
		stages_connection:"ReviewWorkflowsWorkflowStageRelationResponseCollection",
		stages:"ReviewWorkflowsWorkflowStage",
		contentTypes:"JSON",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	ReviewWorkflowsWorkflowEntityResponseCollection:{
		nodes:"ReviewWorkflowsWorkflow",
		pageInfo:"Pagination"
	},
	ReviewWorkflowsWorkflowStage:{
		documentId:"ID",
		name:"String",
		color:"String",
		workflow:"ReviewWorkflowsWorkflow",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	ReviewWorkflowsWorkflowStageEntityResponseCollection:{
		nodes:"ReviewWorkflowsWorkflowStage",
		pageInfo:"Pagination"
	},
	ReviewWorkflowsWorkflowStageRelationResponseCollection:{
		nodes:"ReviewWorkflowsWorkflowStage"
	},
	UsersPermissionsPermission:{
		documentId:"ID",
		action:"String",
		role:"UsersPermissionsRole",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	UsersPermissionsPermissionRelationResponseCollection:{
		nodes:"UsersPermissionsPermission"
	},
	UsersPermissionsRole:{
		documentId:"ID",
		name:"String",
		description:"String",
		type:"String",
		permissions_connection:"UsersPermissionsPermissionRelationResponseCollection",
		permissions:"UsersPermissionsPermission",
		users_connection:"UsersPermissionsUserRelationResponseCollection",
		users:"UsersPermissionsUser",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	UsersPermissionsRoleEntityResponseCollection:{
		nodes:"UsersPermissionsRole",
		pageInfo:"Pagination"
	},
	UsersPermissionsUser:{
		documentId:"ID",
		username:"String",
		email:"String",
		provider:"String",
		confirmed:"Boolean",
		blocked:"Boolean",
		role:"UsersPermissionsRole",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	UsersPermissionsUserEntityResponse:{
		data:"UsersPermissionsUser"
	},
	UsersPermissionsUserEntityResponseCollection:{
		nodes:"UsersPermissionsUser",
		pageInfo:"Pagination"
	},
	UsersPermissionsUserRelationResponseCollection:{
		nodes:"UsersPermissionsUser"
	},
	Blog:{
		documentId:"ID",
		title:"String",
		image:"UploadFile",
		slug:"String",
		writer:"Writer",
		category:"Category",
		content:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	BlogEntityResponseCollection:{
		nodes:"Blog",
		pageInfo:"Pagination"
	},
	Category:{
		documentId:"ID",
		name:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	CategoryEntityResponseCollection:{
		nodes:"Category",
		pageInfo:"Pagination"
	},
	Home:{
		documentId:"ID",
		heroTip:"String",
		usecase:"ComponentLandingWorkExample",
		faq:"ComponentLandingFaq",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	Writer:{
		documentId:"ID",
		name:"String",
		image:"UploadFile",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		publishedAt:"DateTime"
	},
	WriterEntityResponseCollection:{
		nodes:"Writer",
		pageInfo:"Pagination"
	},
	GenericMorph:{
		"...on ComponentLandingWorkExample":"ComponentLandingWorkExample",
		"...on ComponentLandingFaq":"ComponentLandingFaq",
		"...on UploadFile":"UploadFile",
		"...on I18NLocale":"I18NLocale",
		"...on ReviewWorkflowsWorkflow":"ReviewWorkflowsWorkflow",
		"...on ReviewWorkflowsWorkflowStage":"ReviewWorkflowsWorkflowStage",
		"...on UsersPermissionsPermission":"UsersPermissionsPermission",
		"...on UsersPermissionsRole":"UsersPermissionsRole",
		"...on UsersPermissionsUser":"UsersPermissionsUser",
		"...on Blog":"Blog",
		"...on Category":"Category",
		"...on Home":"Home",
		"...on Writer":"Writer"
	},
	UsersPermissionsMe:{
		id:"ID",
		username:"String",
		email:"String",
		confirmed:"Boolean",
		blocked:"Boolean",
		role:"UsersPermissionsMeRole"
	},
	UsersPermissionsMeRole:{
		id:"ID",
		name:"String",
		description:"String",
		type:"String"
	},
	UsersPermissionsPasswordPayload:{
		ok:"Boolean"
	},
	UsersPermissionsLoginPayload:{
		jwt:"String",
		user:"UsersPermissionsMe"
	},
	UsersPermissionsCreateRolePayload:{
		ok:"Boolean"
	},
	UsersPermissionsUpdateRolePayload:{
		ok:"Boolean"
	},
	UsersPermissionsDeleteRolePayload:{
		ok:"Boolean"
	},
	Query:{
		uploadFile:"UploadFile",
		uploadFiles_connection:"UploadFileEntityResponseCollection",
		uploadFiles:"UploadFile",
		i18NLocale:"I18NLocale",
		i18NLocales_connection:"I18NLocaleEntityResponseCollection",
		i18NLocales:"I18NLocale",
		reviewWorkflowsWorkflow:"ReviewWorkflowsWorkflow",
		reviewWorkflowsWorkflows_connection:"ReviewWorkflowsWorkflowEntityResponseCollection",
		reviewWorkflowsWorkflows:"ReviewWorkflowsWorkflow",
		reviewWorkflowsWorkflowStage:"ReviewWorkflowsWorkflowStage",
		reviewWorkflowsWorkflowStages_connection:"ReviewWorkflowsWorkflowStageEntityResponseCollection",
		reviewWorkflowsWorkflowStages:"ReviewWorkflowsWorkflowStage",
		usersPermissionsRole:"UsersPermissionsRole",
		usersPermissionsRoles_connection:"UsersPermissionsRoleEntityResponseCollection",
		usersPermissionsRoles:"UsersPermissionsRole",
		usersPermissionsUser:"UsersPermissionsUser",
		usersPermissionsUsers_connection:"UsersPermissionsUserEntityResponseCollection",
		usersPermissionsUsers:"UsersPermissionsUser",
		blog:"Blog",
		blogs_connection:"BlogEntityResponseCollection",
		blogs:"Blog",
		category:"Category",
		categories_connection:"CategoryEntityResponseCollection",
		categories:"Category",
		home:"Home",
		writer:"Writer",
		writers_connection:"WriterEntityResponseCollection",
		writers:"Writer",
		me:"UsersPermissionsMe"
	},
	Mutation:{
		createReviewWorkflowsWorkflow:"ReviewWorkflowsWorkflow",
		updateReviewWorkflowsWorkflow:"ReviewWorkflowsWorkflow",
		deleteReviewWorkflowsWorkflow:"DeleteMutationResponse",
		createReviewWorkflowsWorkflowStage:"ReviewWorkflowsWorkflowStage",
		updateReviewWorkflowsWorkflowStage:"ReviewWorkflowsWorkflowStage",
		deleteReviewWorkflowsWorkflowStage:"DeleteMutationResponse",
		createBlog:"Blog",
		updateBlog:"Blog",
		deleteBlog:"DeleteMutationResponse",
		createCategory:"Category",
		updateCategory:"Category",
		deleteCategory:"DeleteMutationResponse",
		updateHome:"Home",
		deleteHome:"DeleteMutationResponse",
		createWriter:"Writer",
		updateWriter:"Writer",
		deleteWriter:"DeleteMutationResponse",
		updateUploadFile:"UploadFile",
		deleteUploadFile:"UploadFile",
		createUsersPermissionsRole:"UsersPermissionsCreateRolePayload",
		updateUsersPermissionsRole:"UsersPermissionsUpdateRolePayload",
		deleteUsersPermissionsRole:"UsersPermissionsDeleteRolePayload",
		createUsersPermissionsUser:"UsersPermissionsUserEntityResponse",
		updateUsersPermissionsUser:"UsersPermissionsUserEntityResponse",
		deleteUsersPermissionsUser:"UsersPermissionsUserEntityResponse",
		login:"UsersPermissionsLoginPayload",
		register:"UsersPermissionsLoginPayload",
		forgotPassword:"UsersPermissionsPasswordPayload",
		resetPassword:"UsersPermissionsLoginPayload",
		changePassword:"UsersPermissionsLoginPayload",
		emailConfirmation:"UsersPermissionsLoginPayload"
	}
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const
}